import React from "react";
import { Exclusive } from "./ExclusiveWallet.style";

export const ExclusiveWallet = () => {
  return (
    <Exclusive.Wrapper>
      <div>
        <Exclusive.Title>
          <span>1</span>
          <span>프로비트(ProBit) 거래소 지갑 보유자</span>
        </Exclusive.Title>
        <Exclusive.Text>
          - 보유하신 SKET 토큰이 00월 00일 자동으로 SKET Coin 으로 스왑됩니다. <br />- 거래소 계정에 SKET Token 을
          보유한 경우 00월 00일 진행되는 거래소의 자체 스왑을 기다려주세요.
        </Exclusive.Text>
      </div>
      <Exclusive.Line src="/assets/img/swap_row_line.png" />
      <div>
        <Exclusive.Title>
          <span>2 </span>
          <span>메타마스크 등의</span>
          <span>외부 지갑 보유자</span>
        </Exclusive.Title>
        <Exclusive.Text>
          - 00월 00일 이전에 거래소로 이전하여 스왑을 진행할 수 있습니다.
          <br /> - 00월 00일 이후 혹은, 거래소를 이용하지 않는 경우 구 스케치 월렛으로 디지털자산을 이전한 후, 스왑
          신청해주시길 바랍니다.
        </Exclusive.Text>
      </div>
    </Exclusive.Wrapper>
  );
};
